module.exports = __webpack_public_path__ + "static/media/programmer-man.62ba8da7.webp";